import { Elements } from '@stripe/react-stripe-js'
import { stripePromise } from 'helpers/sf_constants'
import React from 'react'
import BillingRegistration from './BillingRegistration'

const BillingRegistrationWrapper = (props) => {
  return (
    <Elements stripe={stripePromise}>
      <BillingRegistration history={props.history}/>
    </Elements>
  )
}

export default BillingRegistrationWrapper